var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86765 6.99994C9.28186 6.99994 9.61765 7.33573 9.61765 7.74994C9.61765 8.16415 9.28186 8.49994 8.86765 8.49994H8.30294C6.20264 8.49994 4.5 10.2026 4.5 12.3029C4.5 14.4032 6.20264 16.1058 8.30294 16.1058H8.86765C9.28186 16.1058 9.61765 16.4416 9.61765 16.8558C9.61765 17.27 9.28186 17.6058 8.86765 17.6058H8.30294C5.37421 17.6058 3 15.2316 3 12.3029C3 9.37415 5.37421 6.99994 8.30294 6.99994H8.86765ZM14.2235 7.74994C14.2235 7.33573 14.5593 6.99994 14.9735 6.99994H15.5029C18.4317 6.99994 20.8059 9.37415 20.8059 12.3029C20.8059 15.2316 18.4317 17.6058 15.5029 17.6058H14.9735C14.5593 17.6058 14.2235 17.27 14.2235 16.8558C14.2235 16.4416 14.5593 16.1058 14.9735 16.1058H15.5029C17.6032 16.1058 19.3059 14.4032 19.3059 12.3029C19.3059 10.2026 17.6032 8.49994 15.5029 8.49994H14.9735C14.5593 8.49994 14.2235 8.16415 14.2235 7.74994ZM7.32353 12.2863C7.32353 11.8721 7.65932 11.5363 8.07353 11.5363H15.6994C16.1136 11.5363 16.4494 11.8721 16.4494 12.2863C16.4494 12.7005 16.1136 13.0363 15.6994 13.0363H8.07353C7.65932 13.0363 7.32353 12.7005 7.32353 12.2863Z",
    fill: "#5E5E66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.87a91e97.svg";
export { ForwardRef as ReactComponent };